import { useMemo } from 'react';

import { type Props as PermissionsProps, usePermissions } from './use-permissions.hook';

export const createUserSyncPermissions = (permissions: ReturnType<typeof usePermissions>) => {
	const { hasAnyPermission, useUserSync } = permissions;

	// Legacy `hasAccountUserSyncPermission`: the plan and the workspace setting gate every action.
	const canAdmin = () => !!useUserSync && hasAnyPermission('USER_SYNCS_ADMIN');

	return {
		canRead: () => !!useUserSync && hasAnyPermission('USER_SYNCS_READER'),
		canCreate: canAdmin,
		canUpdate: canAdmin,
		canDelete: canAdmin,
		// `syncUsers` is an admin call in the permission handler; legacy showed it to readers, who got a 403.
		canSync: canAdmin,
	};
};

export const useUserSyncPermissions = (props: PermissionsProps) => {
	const permissions = usePermissions(props);

	return useMemo(() => createUserSyncPermissions(permissions), [permissions]);
};
